import React, { Component } from 'react'
import { TerminalsMapProps, TerminalsMapState, TerminalMarker } from './types'
import { Map, GoogleApiWrapper, Marker, MarkerProps, InfoWindow, MapProps } from 'google-maps-react'
import { Config } from 'core'
import { parsePhone } from 'core/utils'
import mrkrImg from 'img/marker2.png'
import Row from 'reactstrap/lib/Row'
import Col from 'reactstrap/lib/Col'
import Container from 'reactstrap/lib/Container'
import Button from 'reactstrap/lib/Button'
import llamar from '../../../../img/llamar.svg'
import llegar from '../../../../img/como-llegar.svg'

React.createElement('div')

export class TerminalsMap extends Component<TerminalsMapProps, TerminalsMapState> {
  state: TerminalsMapState = {}

  handleMarkerClick = (terminal?: TerminalMarker, marker?: google.maps.Marker) => {
    this.setState({
      selectedPlace: terminal,
      activeMarker: marker,
      showingInfoWindow: true
    })
  }

  onClose = () => {
    this.setState(prevState => {
      if (prevState.showingInfoWindow) {
        return {
          showingInfoWindow: true,
          activeMarker: null
        }
      }
      return {}
    })
  }

  onInitMap = (_mapProps?: MapProps, map?: google.maps.Map) => {
    if (map) {
      this.setState({ map })
    }
  }

  render() {
    const { terminals } = this.props
    const { selectedPlace = { name: '', address: '', phone: '', location: { lat: '', lng: '' } }, map } = this.state

    const markerItem = (terminal: TerminalMarker) => {
      return (
        <Marker
          key={terminal.id}
          onClick={(_props?: MarkerProps, marker?: google.maps.Marker) => {
            this.handleMarkerClick(terminal, marker)
          }}
          position={terminal.location}
          icon={{
            scaledSize: {
              height: 50,
              width: 30
            },
            url: mrkrImg
          }}
        />
      )
    }
    const bounds = new this.props.google.maps.LatLngBounds()
    terminals.forEach(t => {
      bounds.extend(t.location)
    })

    return (
      <Map
        google={this.props.google}
        bounds={bounds}
        zoom={8}
        style={{
          width: '94%',
          height: this.props.height
        }}
        initialCenter={{
          lat: 25.7922734,
          lng: -108.9855814
        }}
        onReady={this.onInitMap}
      >
        {terminals.map(markerItem)}
        <InfoWindow
          google={this.props.google}
          map={map}
          marker={this.state.activeMarker}
          visible={this.state.showingInfoWindow}
          onClose={this.onClose}
        >
          <Container style={{ width: '250px' }}>
            <Row>
              <h1 className="big-gray font-weight-bold">{selectedPlace.name || ''}</h1>
            </Row>
            <Row>{selectedPlace.phone ? <p className="big-blue">Tel. {parsePhone(selectedPlace.phone)}</p> : ''}</Row>
            <Row>
              <p className="big-blue">{selectedPlace.address || ''}</p>
            </Row>
            <Row>
              <Col>
                {selectedPlace.phone != null ? (
                  <Button
                    target="_blank"
                    href={`tel:${parsePhone(selectedPlace.phone)}`}
                    outline
                    style={{ width: '80px', height: '45px', background: '#737277', border: 'none', borderRadius: '60px' }}
                  >
                    <Row>
                      <Col>
                        <img style={{ width: '20px', height: '20px' }} src={llamar} /> {'    '}
                      </Col>
                    </Row>
                  </Button>
                ) : (
                  ''
                )}
              </Col>
              <Col>
                <Button
                  target="_blank"
                  href={`https://www.google.com/maps/dir/Current+Location/${selectedPlace.location.lat},${selectedPlace.location.lng}`}
                  outline
                  style={{ width: '80px', height: '45px', borderRadius: '60px', border: 'none', background: '#ff0000' }}
                >
                  <Row>
                    <Col>
                      <img style={{ width: '20px', height: '20px' }} src={llegar} />
                      {'    '}
                    </Col>
                  </Row>
                </Button>
              </Col>
            </Row>
          </Container>
        </InfoWindow>
      </Map>
    )
  }
}

export default GoogleApiWrapper({
  apiKey: Config.maps
})(TerminalsMap)
